import { render, staticRenderFns } from "./DomicilioConsultaBuro.vue?vue&type=template&id=4511fd64&lang=html&"
import script from "./DomicilioConsultaBuro.vue?vue&type=script&lang=js&"
export * from "./DomicilioConsultaBuro.vue?vue&type=script&lang=js&"
import style0 from "./DomicilioConsultaBuro.vue?vue&type=style&index=0&id=4511fd64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports